module.exports = __webpack_public_path__ + "static/img/pay_fail.d02f0eef.png";